import { Component } from '@angular/core';
import {  RouterOutlet } from "@angular/router";

@Component({
  selector: 'app-bundles-managment',
  imports: [RouterOutlet],
  templateUrl: './bundles-managment.html',
  styleUrl: './bundles-managment.scss'
})
export class BundlesManagment {

}
